// C.1 — реестр хилеров Глобала. Пока пустой; новые хилеры будут добавляться
// при реализации соответствующих карт.

const HEALER_IDS = new Set();

export function registerHealer(cardId) {
  HEALER_IDS.add(cardId);
}

export function isHealerCard(cardId) {
  return HEALER_IDS.has(cardId);
}
